import { P } from 'components'
import PMBInputNumber from 'components/PMBInputNumber'
import PMBSelect from 'components/PMBSelect'
import PMBTooltip from 'components/PMBTooltip'
import { useEffect, useRef } from 'react'
import { HelpCircle } from 'react-feather'
import { Button, FormGroup, Modal, ModalBody, Spinner } from 'reactstrap'
import { formatInputNumber } from 'utility/Utils'

const ModalAddItem = ({
  isOpen,
  toggle,
  payload,
  typeOptions,
  handleSelectType,
  commodityOptions,
  handleSelectCommodity,
  handleVolumeChange,
  resetState,
  isFormInvalid,
  handleSubmit,
  isLoadingAddReport,
  isEditMode,
}) => {
  const inputRef = useRef(null)

  // AUTO FOCUS
  useEffect(() => {
    if (isOpen) setTimeout(() => inputRef.current?.focus(), 100)
  }, [isOpen])

  // RESET STATE PAYLOAD
  useEffect(() => {
    if (!isOpen) {
      const timeout = setTimeout(() => {
        resetState()
      }, 300)

      return () => clearTimeout(timeout)
    }
  }, [isOpen])

  return (
    <>
      <Modal
        className="p-4"
        centered
        isOpen={isOpen}
        toggle={toggle}
        autoFocus={false}
        style={{ maxWidth: '600px' }}
        data-testid="pnbp-modal-add-item"
      >
        <ModalBody>
          <div className="d-flex flex-column gap-1">
            <P className="text-sm pb-4" size="medium" color="#101828" bold>
              {isEditMode ? 'Ubah Item' : 'Tambah Item'}
            </P>
          </div>

          <FormGroup>
            <P className="text-sm pb-1" size="regular" color="#344054">
              Jenis<span style={{ color: '#b42218' }}>*</span>
            </P>
            <PMBSelect
              value={payload.itemConfigurations?.[0]?.type}
              options={typeOptions}
              onChange={handleSelectType}
              name="type"
              style={{ width: '100%' }}
              menuPosition="fixed"
              innerRef={inputRef}
              autoFocus
            />
          </FormGroup>

          <FormGroup>
            <P className="text-sm pb-1" size="regular" color="#344054">
              Barang<span style={{ color: '#b42218' }}>*</span>
            </P>
            <PMBSelect
              value={payload.itemConfigurations?.[0]?.commodity}
              options={commodityOptions}
              onChange={handleSelectCommodity}
              name="commodity"
              style={{ width: '100%' }}
              menuPosition="fixed"
            />
          </FormGroup>

          <FormGroup>
            <div className="d-flex align-items-center">
              <P className="text-sm me-1" size="regular" color="#344054">
                PSDH
              </P>
              <HelpCircle id="tooltip-psdh" width={14} />
              <PMBTooltip
                placement="right"
                target="tooltip-psdh"
                text="PROVISI SUMBER DAYA HUTAN"
              />
            </div>
            <PMBInputNumber
              disabled
              value={formatInputNumber(payload.itemConfigurations?.[0]?.psdh)}
              name="psdh"
              prefix="Rp"
              isFirstPrefix
            />
          </FormGroup>

          <FormGroup>
            <div className="d-flex align-items-center">
              <P
                size="regular"
                className="mb-2 d-flex align-items-center"
                color="#344054"
              >
                Volume
                <span style={{ color: '#b42218', marginRight: '4px' }}>*</span>
                {(Number(payload.itemConfigurations?.[0]?.volume) < 1 ||
                  !payload.itemConfigurations?.[0]?.volume) && (
                  <span className="text-xs text-danger">
                    (Minimal lebih dari 0)
                  </span>
                )}
              </P>
            </div>
            <PMBInputNumber
              id="volume"
              name="volume"
              value={formatInputNumber(payload.itemConfigurations?.[0]?.volume)}
              onChange={(e) => handleVolumeChange(e.target.value)}
              placeholder="Masukkan volume"
              min={1}
              prefix={payload.itemConfigurations?.[0]?.unit?.label}
              isLastPrefix
            />
          </FormGroup>

          <FormGroup>
            <div className="d-flex align-items-center">
              <P className="text-sm me-1" size="regular" color="#344054">
                Total
              </P>
            </div>
            <PMBInputNumber
              disabled
              value={formatInputNumber(payload.itemConfigurations?.[0]?.total)}
              prefix="Rp"
              isFirstPrefix
            />
          </FormGroup>

          <div className="d-flex gap-3 mt-3">
            <Button
              onClick={() => toggle()}
              className="btn-cancel"
              outline
              block
              data-testid="pnbp-modal-add-item-cancel"
            >
              Batal
            </Button>
            <Button
              color="primary"
              block
              disabled={isFormInvalid || isLoadingAddReport}
              onClick={handleSubmit}
              data-testid="pnbp-modal-add-item-submit"
            >
              {isLoadingAddReport && <Spinner size="sm" className="me-2" />}
              Simpan
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

export default ModalAddItem
